import React, { useEffect, useState, useContext, useCallback } from 'react';
import { RouteComponentProps } from '@reach/router';
import {
    LayoutStandardCrud,
    FiltersDisplay,
    AntButton,
    BlockLoading3,
} from '@/components';
import { Icon, Tooltip, message } from 'antd';
import _ from 'lodash';
import { StoreContext } from '@/stores';
import { useNet } from '@/utils';
import { observer } from 'mobx-react-lite';
import { runInAction } from 'mobx';
import { dFilterHOC, useDefaultDFilterSnippets } from '@/containers/hoc';
import './index.scss';
import {
    getJobStore,
    getJobTable,
    getFormDrawer,
    getActions,
} from './jobs/registry';

const DemoList: React.FC<RouteComponentProps & {
    type: string;
    tableCode: string;
    dfilters?: any;
    defaultFilters?: any[];
}> = ({
    type = 'all',
    dfilters,
    tableCode,
    defaultFilters: outerDefaultFilters,
}) => {
    const store = useContext(StoreContext);

    const [defaultStore] = useState(() => getJobStore(tableCode));
    const [Table] = useState(() => getJobTable(tableCode));
    const [FormDrawer] = useState(() => getFormDrawer(tableCode));
    const [Actions] = useState(() => getActions(tableCode));
    const userStore = store.getAuthStore();

    const {
        defaultPagination,
        defaultSorter,
        defaultMeta,
        defaultPerm,
        defaultFilter,
        defaultFastFilters,
        condListbyFilterData,
    } = defaultStore;

    const { confirmedfilterData } = defaultFilter;

    const { paginationForFetch } = defaultPagination;

    const { sortersForFetch } = defaultSorter;

    const listFetch = useCallback(() => defaultStore.fetch(), []);
    const [error, loading, reload] = useNet(listFetch, {
        autoLoad: false,
        refreshKeys: [defaultStore.tableCode],
    });

    const [preRequiredReady, setPreRequiredReady] = useState(false);
    // 翻页
    useEffect(() => {
        // 元信息，准备用户可查询的
        if (!preRequiredReady) {
            return;
        }
        reload();
    }, [
        paginationForFetch,
        sortersForFetch,
        condListbyFilterData,
        preRequiredReady,
    ]);

    useEffect(() => {
        if (_.isArray(outerDefaultFilters)) {
            defaultStore.setDefaultFilters(outerDefaultFilters);
        }
    }, [outerDefaultFilters]);

    useEffect(() => {
        if (userStore.userInfo) {
            defaultMeta.setTableId(defaultStore.tableCode);
            defaultMeta.setOpUsername(
                userStore.userInfo.userId + '-tab-' + type,
            );
            defaultFastFilters.setFilters(dfilters);
            Promise.all([defaultMeta.fetch(), defaultPerm.fetch()])
                .then(() => {
                    setPreRequiredReady(true);
                })
                .catch(() => {});
        }
    }, [userStore.userInfo]);

    // 设置filter初始值
    useEffect(() => {
        if (defaultMeta.inited) {
            defaultFilter.resetFilterData();
            defaultFilter.confirmFilterData();
        }
    }, [defaultMeta.inited]);

    useEffect(() => {
        runInAction(() => {
            defaultFastFilters.setType(type);
            defaultStore.setListType(type);
        });
    }, [type]);

    if (!preRequiredReady) {
        return <BlockLoading3 />;
    }

    const filtersDisplay = (
        <FiltersDisplay
            objectMeta={defaultMeta.objectMeta}
            filterData={confirmedfilterData}
            sorterData={defaultStore.defaultSorter}
            onClose={(key: string) => {
                defaultFilter.onFilterClear(key);
            }}
        />
    );

    const popups = (
        <>
            <Actions defaultStore={defaultStore} />
            <FormDrawer
                defaultStore={defaultStore}
                preRequiredReady={preRequiredReady}
            />
        </>
    );

    const globalOps = null;
    const dataTable = (
        <Table noHistory={true} defaultStore={defaultStore} loading={loading} />
    );

    const layoutComs = {
        popups,
        title: null,
        globalOps,
        filters: null,
        multipleOps: null,
        dataTable,
        message: null, // ack ? <Alert closable message={ack} /> : null,
        filtersDisplay,
    };

    return <LayoutStandardCrud className="job-tab" {...layoutComs} />;
};

export const Job4Customer = observer(DemoList);
